module.exports = __webpack_public_path__ + "static/media/icon-wh.f1690d5a.svg";